import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export function StickyHeader() {
    const navigate = useNavigate();
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const navLinks = [
        { name: "Date", href: "#" },
        { name: "Educators Stories", href: "#" },
        { name: "Teacher Safety", href: "#" },
        { name: "Support", href: "#" },
    ];

    return (
        <header
            className={cn(
                "fixed top-0 left-0 right-0 z-50 transition-all duration-300 px-6 py-4",
                isScrolled ? "bg-brand-surface/90 backdrop-blur-md shadow-lg py-3 border-b border-brand-border" : "bg-transparent"
            )}
        >
            <div className="max-w-7xl mx-auto flex items-center justify-between">
                {/* Logo */}
                <div
                    className="text-2xl font-bold text-brand-text cursor-pointer"
                    onClick={() => navigate("/")}
                >
                    Hall Pass
                </div>

                {/* Centered Pill Navigation - Hidden on mobile, visible on md+ */}
                <nav className="hidden md:flex items-center bg-brand-surface/50 backdrop-blur-sm rounded-full px-6 py-2 shadow-sm border border-brand-border">
                    <ul className="flex items-center gap-6">
                        {navLinks.map((link) => (
                            <li key={link.name}>
                                <a
                                    href={link.href}
                                    className="text-sm font-medium text-brand-muted hover:text-brand-primary transition-colors"
                                >
                                    {link.name}
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>

                {/* Auth Buttons */}
                <div className="flex items-center gap-3">
                    <Button
                        variant="ghost"
                        className="text-brand-text hover:text-brand-primary font-semibold rounded-full px-6 transition-all duration-300"
                        onClick={() => navigate("/login")}
                    >
                        Sign In
                    </Button>
                    <Button
                        className="bg-brand-primary text-brand-background hover:bg-brand-primary/90 font-semibold rounded-full px-6 shadow-lg hover:shadow-xl transition-all duration-300"
                        onClick={() => navigate("/role-selection")}
                    >
                        Sign Up
                    </Button>
                </div>
            </div>
        </header>
    );
}
